import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Outlet, useParams } from 'react-router-dom'

import { getCommunityAccessControl } from '../../actions/accessControlActions'
import { reset } from '../../reducers/communityLandingPageReducer'
import Loader from '../common/loader/legacy-loaders/Op36Loader-web'
import AccessCodeRequired from '../classes/AccessCodeRequired/AccessCodeRequired'

const CommunityLandingPageWrapper = () => {
  const dispatch = useDispatch()

  const { communityId } = useParams()
  const user = useSelector(state => state.user.current_user)
  const permittedAt = useSelector(state => state.landingAccess.permittedAt)
  const [permitted, setPermitted] = useState(null)

  useEffect(() => {
    dispatch(reset())

    if (user?.communities?.some((c) => c?.id === Number(communityId)) || localStorage.getItem('guestAccessCode')) {
      setPermitted(true)

      return
    }

    dispatch(getCommunityAccessControl(communityId)).unwrap()
      .then(() => setPermitted(false))
      .catch(() => setPermitted(true))
  }, [dispatch, user, communityId, permittedAt])

  if (permitted === null) {
    return <Loader className='bg-white' message='loading community' />
  }

  return permitted ? <Outlet /> : <AccessCodeRequired />
}

export default CommunityLandingPageWrapper
